module.exports = __webpack_public_path__ + "static/media/reload-icon-white.c02a2994.svg";